import React from "react";
import SideNavigation from "admin/side-navigation";
import { links } from "./lib/sitemap";

const AssignmentLayout = (props) => {
    return (
        <div className="row">
            <div className="column -span1">
                <SideNavigation
                    location={props.location}
                    links={links}
                />
            </div>
            <div className="column -span10">{props.children}</div>
        </div>
    );
};

export default AssignmentLayout;
